import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { UntypedFormGroup, UntypedFormBuilder, Validators } from '@angular/forms';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Animacao } from '../../../core/tools/animacao';
import { ToastrService } from 'ngx-toastr';

/* Services */

import { CallCenterService } from '../../../core/services/call-center/call-center.service';
import { ClienteService } from '../../../core/services/clientes/cliente.service';
import { ExcelService } from '../../../core/tools/excel.service';
import { ProdutoService } from '../../../core/services/produtos/produto.service';

/* Models */

import { CallCenterConfiguracao } from '../../../core/models/call-center/call-center-configuracao';
import { CallCenterOportunidade } from '../../../core/models/call-center/call-center-oportunidade';
import { CallCenterOportunidadeFiltrar } from '../../../core/models/call-center/call-center-oportunidade-filtrar';
import { ClienteTag } from '../../../core/models/clientes/cliente-tag';
import { Estatistica } from '../../../core/models/pedidos/estatistica';
import { Produto } from '../../../core/models/produtos/produto';

@Component({
    selector: 'app-dashboard-oportunidades',
    templateUrl: './dashboard-oportunidades.component.html',
    styleUrls: ['./dashboard-oportunidades.component.css'],
    preserveWhitespaces: false,
    animations: [Animacao],
    standalone: false
})

export class DashboardOportunidadesComponent implements OnInit {
  /* Carregamento */

  carregando: boolean = false;

  /* Dados */

    /* Filtro (Produtos) */

    produtoEmBranco: boolean = false;
    produtoInvalido: boolean = false;

    produtos: Produto[] = [];
    produtosOriginal: Produto[] = [];

    produtoSelecionado: Produto = null;

  /* Filtros */

  formFiltro: UntypedFormGroup;

  opcoes = { cidades: [] as string[], bairros: [] as string[], classificacoes: [] as string[], segmentos: [] as string[], tags: [] as string[], vendedores: [] as string[] };
  carregandoOpcoes = false;
  carregandoBairros = false;
  erroOpcoes = false;
  erroBairros = false;
  buscando = false;
  filtrosRecolhidos = false;
  mostrarBuscaProduto = false;
  carregandoProdutos = false;
  private versaoCidade = 0;
  intervalos = [
    { label: 'Dias sem compra', inicio: 'nro_inicial_sem_compra', fim: 'nro_final_sem_compra' },
    { label: 'Dias sem visita', inicio: 'nro_inicial_sem_visita', fim: 'nro_final_sem_visita' },
    { label: 'Realizado ano (R$)', inicio: 'valor_inicial_realizado_ano', fim: 'valor_final_realizado_ano' },
    { label: 'Realizado mês (R$)', inicio: 'valor_inicial_realizado_mes', fim: 'valor_final_realizado_mes' }
  ];

  enviado: boolean = false;
  filtrado: boolean = false;
  filtradoVendedor: boolean = false;

  /* Filtro (Produtos) */

  formFiltroProduto: UntypedFormGroup;

  filtroProdutos: any[] = [
    { texto: "Código", valor: "0" },
    { texto: "Descrição", valor: "1" },
    { texto: "Marca", valor: "2" }
  ];

  enviadoProduto: boolean = false;

  filtrandoProduto: boolean = false;

  /* Tags */

  tagFiltro: string[] = [];

  /* Ordernar (Oportunidades) */

  ordernarOportunidadesOpcoes: any[] = [];

  ordernarOportunidadesOpcoesOrdem: any[] = [
    { texto: "Crescente", valor: "0" },
    { texto: "Decrescente", valor: "1" }
  ];

  ordernarOportunidadesSelecionado: string = "name";
  ordernarOportunidadesOrdemSelecionado: string = "0";

  /* Call Center (Configurações) */

  callCenterConfiguracao: CallCenterConfiguracao = null;

  /* Call Center (Oportunidades) */

  oportunidades: CallCenterOportunidade[] = [];

  /* Classificações */


  /* Acompanhamento */

  /* Oportunidades */

  qtdeClientes: number = 0;
  qtdeClientesPadrao: number = 0;
  qtdeClientesAdicionais: number = 0;
  valorMetaMes: number = 0;

  /* Estatística (Status do Pedido) */

  estatisticasClientes: Estatistica[] = [];

  /* Tags (Clientes) */

  tagCliente: any = [];
  tagClienteOpcoes: any = [];

  tagClienteIdSelecionado: number = 0;
  tagClienteNomeSelecionado: string = "";

  /* Storage */

  modelo_tela_ligacoes: number = parseInt(localStorage.getItem("modelo_tela_ligacoes"));

  constructor(
    private router: Router,
    private formBuilder: UntypedFormBuilder,
    private modalService: NgbModal,
    private toastr: ToastrService,
    private callCenterService: CallCenterService,
    private clienteService: ClienteService,
    private excelService: ExcelService,
    private produtoService: ProdutoService
  ) { }

  ngOnInit() {
    /* Filtros */

    const campos: any = {};
    ['cidade', 'bairro', 'classificacao', 'cliente', 'cnpj_cpf', 'codigo', 'segmento', 'vendedor'].forEach(c => campos[c] = ['']);
    this.intervalos.forEach(i => {
      campos[i.inicio] = ['', [Validators.min(0), Validators.pattern(/^\d+$/)]];
      campos[i.fim] = ['', [Validators.min(0), Validators.pattern(/^\d+$/)]];
    });
    this.formFiltro = this.formBuilder.group(campos, { validators: group =>
      this.intervalos.some(i => {
        const inicio = group.get(i.inicio).value, fim = group.get(i.fim).value;
        return inicio !== '' && inicio != null && fim !== '' && fim != null && Number(inicio) > Number(fim);
      }) ? { intervalo: true } : null
    });
    this.carregarOpcoes();

    /* Filtro (Produtos) */

    this.formFiltroProduto = this.formBuilder.group({
      filtro: ["1"],
      codigo: ["", Validators.required],
      descricao: ["", Validators.required],
      marca: ["", Validators.required]
    });

    this.organizarFiltroProduto();

    /* Ordernar (Oportunidades) */

    if (this.modelo_tela_ligacoes == 0) {
      /* Modelo 1 */

      this.ordernarOportunidadesOpcoes = [
        { texto: "Status", valor: "relationship" },
        { texto: "Agendamento", valor: "call_center_prox_agenda" },
        { texto: "Cliente", valor: "name" },
        { texto: "Cidade", valor: "cidade" },
        { texto: "Estado", valor: "estado" },
        { texto: "CNPJ/CPF", valor: "client_document" },
        { texto: "Segmento", valor: "segment" },
        { texto: "Vendedor(a)", valor: "fullname" },
        { texto: "Ult. Visita", valor: "ultvisita" },
        { texto: "Ult. Visita Dias", valor: "qtdediasultvisita" },
        { texto: "Ult. Compra", valor: "ultcomp" },
        { texto: "Ult. Compra Dias", valor: "qtdediasultcomp" },
        { texto: "Objetivo", valor: "objetivo_de_venda" },
        { texto: "Realizado", valor: "order_total" },
        { texto: "Falta Vender", valor: "falta_vender" },
        { texto: "Atenção", valor: "atencao" }
      ];
    } else if (this.modelo_tela_ligacoes == 1) {
      /* Modelo 2 */

      this.ordernarOportunidadesOpcoes = [
        { texto: "Status", valor: "relationship" },
        { texto: "Agendamento", valor: "call_center_prox_agenda" },
        { texto: "Cliente", valor: "name" },
        { texto: "Estado", valor: "estado" },
        { texto: "CNPJ/CPF", valor: "client_document" },
        { texto: "PV", valor: "pv" },
        { texto: "Segmento", valor: "segment" },
        { texto: "Zona", valor: "zona_vendas" },
        { texto: "Ult. Visita", valor: "ultvisita" },
        { texto: "Ult. Visita Dias", valor: "qtdediasultvisita" },
        { texto: "Ult. Compra", valor: "ultcomp" },
        { texto: "Ult. Compra Dias", valor: "qtdediasultcomp" },
        { texto: "Potêncial Ano", valor: "potencial_ano" },
        { texto: "Realizado Ano", valor: "realizado_ano" },
        { texto: "% Ano", valor: "porcentagem_ano" },
        { texto: "Falta Ano", valor: "falta_ano" },
        { texto: "Objetivo Mês", valor: "objetivo_de_venda" },
        { texto: "Realizado Mês", valor: "realizado_venda" },
        { texto: "% Mês", valor: "porcentagem_venda" },
        { texto: "Mês Anterior", valor: "realizado_venda_mesanterior" },
        { texto: "Atenção", valor: "atencao" }
      ];
    }

    this.carregarDadosOportunidades();
  }

  get f() {
    return this.formFiltro.controls;
  }

  get fp() {
    return this.formFiltroProduto.controls;
  }

  /* Ações */

  consultarCliente(client_id_app: number) {
    this.router.navigate(["/call-center-ligacao"], {
      queryParams: {
        cliente_consulta: client_id_app
      }
    });
  }

  /* Dados */

  calcularDadosOportunidades() {
    this.valorMetaMes = 0;
    this.qtdeClientes = 0;
    this.qtdeClientesPadrao = 0;
    this.qtdeClientesAdicionais = 0;
    this.estatisticasClientes = [];
    if (this.oportunidades.length > 0) {
      /* Meta do Mês */

      this.valorMetaMes = this.oportunidades.reduce((sum, current) => sum + current.falta_vender, 0);

      /* Acompanhamento */

      this.qtdeClientes = this.oportunidades.length;
      this.qtdeClientesPadrao = this.oportunidades.filter(oportunidades => oportunidades.origem == "CARTEIRA").length;
      this.qtdeClientesAdicionais = this.oportunidades.filter(oportunidades => oportunidades.origem == "ADICIONAL").length;

      /* Estatística (Clientes) */

      this.estatisticasClientes = [];

      /* Ativo */

      let qtdeAtivo: number = this.oportunidades.filter(oportunidades => oportunidades.relationship == "Ativo").length;
      let porcentagemAtivo: number = 0;

      if (qtdeAtivo > 0) {
        porcentagemAtivo = ((qtdeAtivo / this.qtdeClientes) * 100);
      }

      this.estatisticasClientes.push(new Estatistica("ativo", "Ativo", qtdeAtivo, null, qtdeAtivo, porcentagemAtivo));

      /* Ativo batido */

      let qtdeAtivoBatido: number = this.oportunidades.filter(oportunidades => oportunidades.relationship == "Ativo batido").length;
      let porcentagemAtivoBatido: number = 0;

      if (qtdeAtivoBatido > 0) {
        porcentagemAtivoBatido = ((qtdeAtivoBatido / this.qtdeClientes) * 100);
      }

      this.estatisticasClientes.push(new Estatistica("ativo_batido", "Ativo (Batido)", qtdeAtivoBatido, null, qtdeAtivoBatido, porcentagemAtivoBatido));

      /* Ativo Premium */

      let qtdeAtivoPremium = this.oportunidades.filter(oportunidades => oportunidades.relationship == "Ativo Premium").length;
      let porcentagemAtivoPremium = 0;

      if (qtdeAtivoPremium > 0) {
        porcentagemAtivoPremium = ((qtdeAtivoPremium / this.qtdeClientes) * 100);
      }

      this.estatisticasClientes.push(new Estatistica("ativo_premium", "Ativo (Premium)", qtdeAtivoPremium, null, qtdeAtivoPremium, porcentagemAtivoPremium));

      /* Inativo */

      let qtdeInativo: number = this.oportunidades.filter(oportunidades => oportunidades.relationship == "Inativo").length;
      let porcentagemInativo: number = 0;

      if (qtdeInativo > 0) {
        porcentagemInativo = ((qtdeInativo / this.qtdeClientes) * 100);
      }

      this.estatisticasClientes.push(new Estatistica("inativo", "Inativo", qtdeInativo, null, qtdeInativo, porcentagemInativo));

      /* Prospecção */

      let qtdeProspeccao: number = this.oportunidades.filter(oportunidades => oportunidades.relationship == "Prospecção").length;
      let porcentagemProspeccao: number = 0;

      if (qtdeProspeccao > 0) {
        porcentagemProspeccao = ((qtdeProspeccao / this.qtdeClientes) * 100);
      }

      this.estatisticasClientes.push(new Estatistica("prospeccao", "Prospecção", qtdeProspeccao, null, qtdeProspeccao, porcentagemProspeccao));

      this.estatisticasClientes.sort((a, b) => {
        const compare = (v1, v2) => v1 == null ? -1 : v1 < v2 ? -1 : v1 > v2 ? 1 : 0;

        return compare(a["qtde"], b["qtde"]) * -1; /* Decrescente */
      });
    }
  }

  carregarDadosOportunidades() {
    this.carregando = true;

    /* Call Center (Configurações) */

    this.callCenterService.getConfiguracaoByGuidClienteNapis().subscribe(
      callCenterConfiguracao => this.callCenterConfiguracao = callCenterConfiguracao,
      error => { console.log("Erro: " + error) },
      () => {
        this.carregando = false;
        if (this.callCenterConfiguracao?.mostra_classificacao && !this.ordernarOportunidadesOpcoes.some(o => o.valor === 'classificacao')) {
          this.ordernarOportunidadesOpcoes.push({ texto: 'Classificação', valor: 'classificacao' });
        }
      }
    );
  }

  /* Exportar */

  exportarOportunidades() {
    this.excelService.exportAsExcelFile(this.oportunidades, "Oportunidades");
  }

  /* Filtros */

  carregarOpcoes() {
    this.carregandoOpcoes = true;
    this.erroOpcoes = false;
    const versao = ++this.versaoCidade;
    this.callCenterService.getOportunidadeFiltroOpcoes(this.f.cidade.value || '').subscribe({
      next: opcoes => {
        this.opcoes.cidades = opcoes.cidades;
        this.opcoes.classificacoes = opcoes.classificacoes;
        this.opcoes.segmentos = opcoes.segmentos;
        this.opcoes.tags = opcoes.tags;
        this.opcoes.vendedores = opcoes.vendedores;
        if (versao === this.versaoCidade) {
          this.opcoes.bairros = opcoes.bairros;
          this.carregandoBairros = false;
          this.erroBairros = false;
        }
        this.carregandoOpcoes = false;
      },
      error: () => { this.carregandoOpcoes = false; this.erroOpcoes = true; }
    });
  }

  alterarCidade(cidade: string) {
    this.f.cidade.setValue(cidade);
    this.f.bairro.setValue('');
    this.opcoes.bairros = [];
    this.carregandoBairros = true;
    this.erroBairros = false;
    const versao = ++this.versaoCidade;
    this.callCenterService.getOportunidadeFiltroOpcoes(cidade, true).subscribe({
      next: opcoes => {
        if (versao !== this.versaoCidade) return;
        this.opcoes.bairros = opcoes.bairros;
        this.carregandoBairros = false;
      },
      error: () => {
        if (versao !== this.versaoCidade) return;
        this.carregandoBairros = false;
        this.erroBairros = true;
      }
    });
  }

  adicionarTag(tag: string) {
    if (tag && !this.tagFiltro.includes(tag)) this.tagFiltro = [...this.tagFiltro, tag];
  }

  removerTag(tag: string) { this.tagFiltro = this.tagFiltro.filter(t => t !== tag); }

  limparFiltros() {
    this.filtrosRecolhidos = false;
    this.formFiltro.reset();
    this.tagFiltro = [];
    this.produtoSelecionado = null;
    this.mostrarBuscaProduto = false;
    this.enviado = this.filtrado = this.filtradoVendedor = false;
    this.oportunidades = [];
    this.calcularDadosOportunidades();
    this.alterarCidade('');
  }

  buscarProduto() {
    this.mostrarBuscaProduto = !this.mostrarBuscaProduto;
    if (!this.mostrarBuscaProduto || this.produtosOriginal.length || this.carregandoProdutos) return;
    this.carregandoProdutos = true;
    this.produtoService.getByGuidClienteNapis().subscribe({
      next: produtos => {
        this.produtos = produtos;
        this.produtosOriginal = [...produtos];
        this.carregandoProdutos = false;
      },
      error: () => { this.carregandoProdutos = false; this.toastr.error('', 'Erro ao carregar produtos.'); }
    });
  }

  filtrar() {
    this.enviado = true;

    if (this.formFiltro.valid && !this.buscando) {
      this.filtrado = true;
      const filtrar = new CallCenterOportunidadeFiltrar();
      const valores = this.formFiltro.value;
      ['cidade', 'bairro', 'classificacao', 'cliente', 'cnpj_cpf', 'codigo', 'segmento', 'vendedor'].forEach(c => {
        if (valores[c]?.trim()) filtrar[c] = valores[c].trim();
      });
      this.intervalos.forEach(i => [i.inicio, i.fim].forEach(c => {
        if (valores[c] !== '' && valores[c] != null) filtrar[c] = Number(valores[c]);
      }));
      filtrar.filtros_combinados = true;
      filtrar.tags = [...this.tagFiltro];
      if (this.produtoSelecionado) filtrar.id_produto = this.produtoSelecionado.id;
      this.filtradoVendedor = !!filtrar.vendedor;
      this.buscando = true;
      this.filtrosRecolhidos = true;
      this.mostrarBuscaProduto = false;

      /* Call Center(Oportunidades) */

      this.oportunidades = [];

      this.callCenterService.getOportunidadeByUsuario(filtrar).subscribe(
        oportunidades => { this.oportunidades = oportunidades; this.buscando = false; },
        error => { this.buscando = false; this.filtrosRecolhidos = false; this.toastr.error("", "Erro ao consultar oportunidades."); },
        () => {
          this.oportunidades.forEach((item) => {
            if ((item.objetivo_de_venda - item.order_total) < 0) {
              item.falta_vender = 0;
            } else {
              item.falta_vender = item.objetivo_de_venda - item.order_total;
            }
          });

          if (this.modelo_tela_ligacoes == 1) {
            /* Modelo 2 */

            this.oportunidades.sort((a, b) => {
              const compare = (v1, v2) => v1 == null ? -1 : v1 < v2 ? -1 : v1 > v2 ? 1 : 0;

              return compare(a["ultvisita"], b["ultvisita"]);
            });

            this.ordernarOportunidadesSelecionado = "ultvisita";
          }

          this.calcularDadosOportunidades();

          if (this.oportunidades.length == 0) {
            this.toastr.error("", "Nenhuma oportunidade encontrada!");
          }
        }
      );
    }
  }

  alterarFiltroProduto(filtro_selecionado: number) {
    this.reiniciarDadosProduto();

    let filtroAtual: string = this.formFiltroProduto.controls["filtro"].value;

    this.formFiltroProduto.reset();

    if (filtro_selecionado == null) {
      this.formFiltroProduto.controls["filtro"].setValue(filtroAtual);
    } else {
      this.formFiltroProduto.controls["filtro"].setValue(filtro_selecionado);
    }

    this.organizarFiltroProduto();

    this.enviadoProduto = false;
    this.filtrandoProduto = false;
  }

  filtrarProduto() {
    this.enviadoProduto = true;

    if (this.formFiltroProduto.invalid) {
      return;
    }

    this.reiniciarDadosProduto();

    if (this.formFiltroProduto.controls["filtro"].value == "0") {
      /* Código */

      if (this.formFiltroProduto.controls["codigo"].value != "" && this.formFiltroProduto.controls["codigo"].value != null) {
        this.produtos = this.produtos.filter(produto => {
          if (produto.codigo == null) {
            return false;
          } else {
            return (produto.codigo.toLowerCase().indexOf(this.formFiltroProduto.controls["codigo"].value.trim().toLowerCase()) !== -1);
          }
        });
      }
    } else if (this.formFiltroProduto.controls["filtro"].value == "1") {
      /* Descrição */

      if (this.formFiltroProduto.controls["descricao"].value != "" && this.formFiltroProduto.controls["descricao"].value != null) {
        this.produtos = this.produtos.filter(produto => {
          if (produto.name == null) {
            return false;
          } else {
            return (produto.name.toLowerCase().indexOf(this.formFiltroProduto.controls["descricao"].value.trim().toLowerCase()) !== -1);
          }
        });
      }
    } else if (this.formFiltroProduto.controls["filtro"].value == "2") {
      /* Marca */

      if (this.formFiltroProduto.controls["marca"].value != "" && this.formFiltroProduto.controls["marca"].value != null) {
        this.produtos = this.produtos.filter(produto => {
          if (produto.grupo_estoque == null) {
            return false;
          } else {
            return (produto.grupo_estoque.toLowerCase().indexOf(this.formFiltroProduto.controls["marca"].value.trim().toLowerCase()) !== -1);
          }
        });
      }
    }

    this.filtrandoProduto = true;
  }

  organizarFiltroProduto() {
    if (this.formFiltroProduto.controls["filtro"].value == "0") {
      /* Código */

      this.formFiltroProduto.get("codigo").enable();
      this.formFiltroProduto.get("descricao").disable();
      this.formFiltroProduto.get("marca").disable();
    } else if (this.formFiltroProduto.controls["filtro"].value == "1") {
      /* Descrição */

      this.formFiltroProduto.get("codigo").disable();
      this.formFiltroProduto.get("descricao").enable();
      this.formFiltroProduto.get("marca").disable();
    } else if (this.formFiltroProduto.controls["filtro"].value == "2") {
      /* Marca */

      this.formFiltroProduto.get("codigo").disable();
      this.formFiltroProduto.get("descricao").disable();
      this.formFiltroProduto.get("marca").enable();
    }
  }

  reiniciarDadosProduto() {
    this.produtos = JSON.parse(JSON.stringify(this.produtosOriginal));
  }

  selecionarProdutoFiltrado(id_produto: number) {
    let produtoSelecionado = this.produtos.find(produtos => produtos.id == id_produto);

    if (produtoSelecionado != null) {
      this.produtoSelecionado = produtoSelecionado;

      if (this.produtoSelecionado.qtde_lote == 0) {
        this.produtoSelecionado.valor = this.produtoSelecionado.price;
      } else {
        this.produtoSelecionado.valor = null;
      }

      this.alterarFiltroProduto(null);

      this.produtoEmBranco = false;
      this.produtoInvalido = false;
      this.filtrandoProduto = false;

      this.mostrarBuscaProduto = false;
      this.filtrar();
    }
  }

  /* Modal */

  modalTagsClientes(content: any, origem: string, id_cliente: number) {
    this.tagCliente = [];

    this.tagClienteIdSelecionado = 0;
    this.tagClienteNomeSelecionado = "";

    switch (origem) {
      case "oportunidades":
        let oportunidadeSelecionada = this.oportunidades.find(oportunidade => oportunidade.client_id_app == id_cliente);

        if (oportunidadeSelecionada != null) {
          oportunidadeSelecionada.cliente_tags.forEach((item) => {
            this.tagCliente.push({
              tagLabel: item.descricao,
              tagValue: item.descricao
            });
          });

          this.tagClienteIdSelecionado = oportunidadeSelecionada.client_id_app;
          this.tagClienteNomeSelecionado = oportunidadeSelecionada.name;
        }

        break;
      default:

    }

    if (this.tagClienteIdSelecionado != 0) {
      this.modalService.open(content, {
        ariaLabelledBy: "titulo-tags-clientes",
        size: "lg",
        backdrop: "static"
      }).result.then((acao) => {
        if (acao == "Salvar") {
          let tags: string[] = [];

          this.tagCliente.forEach((item) => {
            tags.push(item.tagValue);
          });

          let adicionarTag: boolean = false;

          this.clienteService.addTag(this.tagClienteIdSelecionado, tags).subscribe(
            adicionarTags => adicionarTag = adicionarTags,
            error => { console.log("Erro: " + error) },
            () => {
              if (adicionarTag) {
                switch (origem) {
                  case "oportunidades":
                    let oportunidadeSelecionada: CallCenterOportunidade = this.oportunidades.find(oportunidade => oportunidade.client_id_app == id_cliente);

                    if (oportunidadeSelecionada != null) {
                      oportunidadeSelecionada.cliente_tags = [];

                      tags.forEach((item) => {
                        let tag = new ClienteTag();

                        tag.client_id_app = id_cliente;
                        tag.descricao = item;

                        oportunidadeSelecionada.cliente_tags.push(tag);
                      });
                    }

                    break;
                  default:
                }

                this.toastr.success("", "Tag(s) salva(s) com sucesso!");
                this.carregarOpcoes();
              }
            }
          );
        }
      }, () => {

      });
    }
  }

  /* Ordernar (Oportunidades) */

  ordernarOportunidades(opcao_selecionada: string) {
    let oportunidadesAnterior = this.oportunidades;

    this.ordernarOportunidadesSelecionado = opcao_selecionada;

    switch (this.ordernarOportunidadesOrdemSelecionado) {
      case "0":
        /* Crescente */

        oportunidadesAnterior.sort((a, b) => {
          const compare = (v1, v2) => v1 == null ? -1 : v1 < v2 ? -1 : v1 > v2 ? 1 : 0;

          return compare(a[this.ordernarOportunidadesSelecionado], b[this.ordernarOportunidadesSelecionado]);
        });

        break;
      case "1":
        /* Decrescente */

        oportunidadesAnterior.sort((a, b) => {
          const compare = (v1, v2) => v1 == null ? -1 : v1 < v2 ? -1 : v1 > v2 ? 1 : 0;

          return compare(a[this.ordernarOportunidadesSelecionado], b[this.ordernarOportunidadesSelecionado]) * -1; /* Decrescente */
        });

        break;
      default:

    }

    this.oportunidades = JSON.parse(JSON.stringify(oportunidadesAnterior));
  }

  ordernarOportunidadesOrdem(opcao_selecionada: string) {
    this.ordernarOportunidadesOrdemSelecionado = opcao_selecionada;

    this.ordernarOportunidades(this.ordernarOportunidadesSelecionado);
  }

  ordernarOportunidadesOrganizarOpcoes() {
    this.ordernarOportunidadesOpcoes.sort((a, b) => {
      const compare = (v1, v2) => v1 == null ? -1 : v1 < v2 ? -1 : v1 > v2 ? 1 : 0;

      return compare(a["texto"], b["texto"]);
    });
  }
}
